import { useElement } from './core/element.js';
const name = 's-scroll-view';
const props = {};
const style = `:host{display:block;overflow:auto}@media (any-pointer: fine){:host::-webkit-scrollbar{background:transparent;width:6px;height:6px}:host::-webkit-scrollbar-thumb{background:var(--s-color-outline-variant, #C0C8CC);border-radius:3px}@supports not selector(::-webkit-scrollbar){:host{scrollbar-color:var(--s-color-outline-variant, #C0C8CC) transparent}}}`
const template = `<slot></slot>`
class ScrollView extends useElement({
    style, template, props
}) {
}
ScrollView.define(name);
export { ScrollView };
